export const formatVersion = (version: any) => {
  if (!version) return ''

  return version.majorVersion + '.' + version.minorVersion
}
